import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { FormFiltersBackground, PageMain } from "components/molecules";
import { QUERIES_KEYS } from "queries";
import {
  CourseRegistrationsByCourseRow,
  PlaceCoursesReportCourseRow,
  PlaceCoursesReportRow,
  reportsApi,
} from "api/reportsApi";
import { PaziaDateSelect } from "components/atoms";
import { TanTableClient, useFilters, TanTableColumn } from "components/molecules";
import { PaziaBreadcrumbs } from "components/atoms";
import { routes } from "consts";
import { REPORTS_IDS, REPORTS_NAMES } from "consts/reports";

export const PlaceCoursesReport = () => {
  const { filter, changeFilter } = useFilters();
  const [selectedRow, setSelectedRow] = useState<PlaceCoursesReportRow | null>(null);
  const { data, isLoading, refetch } = useQuery({
    queryKey: QUERIES_KEYS.REPORTS.PLACE_COURSES_REPORT(),
    queryFn: () => reportsApi.getPlaceCoursesReport(filter),
  });

  useEffect(() => {
    refetch();
  }, [filter]);

  const columns: TanTableColumn<PlaceCoursesReportRow>[] = [
    {
      id: "placeId",
      accessorKey: "placeId",
      header: "Id",
      size: 10,
    },
    {
      id: "placeName",
      accessorKey: "placeName",
      header: "Miejsce",
      size: 500,
    },
    {
      id: "numberOfCourses",
      accessorKey: "numberOfCourses",
      header: "Liczba kursów",
    },
    {
      id: "numberOfEvents",
      accessorKey: "numberOfEvents",
      header: "Liczba wydarzeń",
    },
  ];

  const onFromDateChange = (date: Date | null) =>
    changeFilter("from", date ? `createdDate ge ${date.toISOString()}` : "");

  const onToDateChange = (date: Date | null) => changeFilter("to", date ? `createdDate le ${date.toISOString()}` : "");

  const tableData = data?.data ?? [];

  return (
    <PageMain>
      <PaziaBreadcrumbs
        segments={[{ title: "Raporty", path: routes.REPORTS }, { title: REPORTS_NAMES[REPORTS_IDS.PLACE_COURSES] }]}
      />

      <div className="pt-4">
        <TanTableClient data={tableData} columns={columns} onRowClick={(x) => setSelectedRow(x)} />
      </div>
      {selectedRow && (
        <div>
          <h2 className="pb-2 pt-6 text-center text-sm">
            Szczegółowa lista dla wybranego miejsca <span className="font-semibold">{selectedRow.placeName}</span>
          </h2>
          <TanTableClient data={selectedRow.courses} columns={courseColumns} pageSize={1_000_000} hidePagination />
        </div>
      )}
    </PageMain>
  );
};

const courseColumns: TanTableColumn<PlaceCoursesReportCourseRow>[] = [
  {
    id: "courseId",
    accessorKey: "courseId",
    header: "Id",
    size: 10,
  },
  {
    id: "courseName",
    accessorKey: "courseName",
    header: "Kurs",
    size: 500,
  },
  {
    id: "numberOfEvents",
    accessorKey: "numberOfEvents",
    header: "Liczba",
    cell: (row) => `${row.getValue()} wydarzeń`,
  },
];
